<template>
<div class="containerWrapper">
  <div class="container">
    <div class="row">
      <div v-if="this.objectDataItem.data !== undefined && this.objectDataItem.data.name !== undefined" class="col-md-12">
        <h1>{{this.objectDataItem.data.name}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Uid</label>
        <div class="d-flex align-items-center">
          <input type="text" v-model="objectDataItem.uid" class="form-control mr-2" :disabled="isDisabled" />
          <i @click="toggleDisabled()" class="pi pi-lock"></i>
         </div>
        <form>
          <vue-form-generator :schema="objectSchema" :model="objectDataItem.data" />
        </form>
      </div>
    </div>
    <div class="row" v-if="objectSchema.objectProps.hasComments">
      <div class="col-md-12">
        <div class="commentListWrapper">
          <CommentList :objectId="objectDataItem.objectId" />
          <CommentCreate :objectId="objectDataItem.objectId" />
        </div>
      </div>
    </div>
    <div class="row" v-if="objectSchema.objectProps.hasLocation">
      <div class="col-md-12">
        <Map
            :dataArray = "mapArray"
            appId="r3da84nDNIcneFJcNZKs"
            appCode="clMPTmhpQrJjfQnXXu_posxIz1Cl8Rcr_4na-rWGWws"
            width="100%"
            zoom = "false"
            height="500px"
            :getGeoCoder="true"
            :draggable= true />
      </div>
    </div>
  </div>
  <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <Button v-if="objectDataItem.objectDescriptionId == 5" @click="onSyncToTSTruck()" label="Synka med TS" class="p-button-success" icon="pi pi-check" ></Button>
        <Button v-if="objectDataItem.objectDescriptionId == 8" @click="onSyncToTSTrailer()" label="Synka med TS" class="p-button-success" icon="pi pi-check" ></Button>
        <Button  label="Spara" class="p-button-success" @click="onSave()" icon="pi pi-check" ></Button>
        <Button  label="Ta bort" class="p-button-danger" @click="onDelete()" icon="pi pi-times" ></Button>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
  <Toast position="topright" />
</div>
</template>

<script>

import VueFormGenerator from 'vue-form-generator'
import CommentList from '../Comments/CommentList'
import CommentCreate from '../Comments/CommentCreate'
import Map from '@/components//Map/Map'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import { bus } from '../../main'
export default {
  name: 'ObjectDataCreate',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    CommentList,
    CommentCreate,
    Button,
    Map,
    Toast
  },
  data () {
    return {
      objectDataItem: {},
      objectSchema: {},
      mapArray: [],
      isDisabled: true
    }
  },
  watch: {
    objectSchema: function (newVal, oldVal) {
      this.objectSchema = newVal
    },
    objectDataItem: function (newVal, oldVal) {
      this.objectDataItem = newVal
    }
  },
  async mounted () {
    bus.$on('updateObjectDataItem', (dataArray) => {
      this.objectDataItem.data.latitude = dataArray.Latitude
      this.objectDataItem.data.longitude = dataArray.Longitude
    })
  },
  async created () {
    this.objectSchema = this.$route.params.schema
    this.objectDataId = this.$route.params.id
    var url = '/api/objectdatas/' + this.$route.params.id
    this.$http
      .get(url)
      .then(response => {
        this.objectDataItem = response.data
        if (this.objectSchema.objectProps.hasLocation) {
          this.mapArray = [
            {Name: this.objectDataItem.data.name, Latitude: this.objectDataItem.data.latitude, Longitude: this.objectDataItem.data.longitude, Title: this.objectDataItem.data.name, Data: this.objectDataItem.data.name, Address: this.objectDataItem.data.address, Postal: this.objectDataItem.data.postal, City: this.objectDataItem.data.city}
          ]
        }
      })
      .catch(error => console.log(error))
    await this.doAPICalls()
  },
  methods: {
    toggleDisabled () {
      this.isDisabled = !this.isDisabled
    },
    onSave () {
      var url = '/api/objectdatas/' + this.objectDataItem.id
      this.$http
        .put(url, {
          objectdata: {
            uid: this.objectDataItem.uid,
            data: this._.omit(this.objectDataItem.data, 'submit')
          }
        })
        .then(response => {
          this.$router.push('/ObjectDataList/' + this.$route.params.objectDataListId)
        })
        .catch(error => console.log(error))
    },
    onSyncToTSTruck () {
      var url = '/api/objectdatas/synctots/truck/' + this.objectDataItem.id
      this.$http
        .put(url, {
          objectdata: {
            uid: this.objectDataItem.uid,
            data: this._.omit(this.objectDataItem.data, 'submit')
          }
        })
        .then(response => {
          this.objectDataItem.uid = response.data.uid
          this.$toast.add({severity: 'success', summary: 'Lastbil sparad i TS', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onSyncToTSTrailer () {
      var url = '/api/objectdatas/synctots/trailer/' + this.objectDataItem.id
      this.$http
        .put(url, {
          objectdata: {
            uid: this.objectDataItem.uid,
            data: this._.omit(this.objectDataItem.data, 'submit')
          }
        })
        .then(response => {
          this.objectDataItem.uid = response.data.uid
          this.$toast.add({severity: 'success', summary: 'Lastbil sparad i TS', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onDelete () {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/objectdatas/' + this.objectDataItem.id
          this.$http
            .delete(url)
            .then(response => {
              this.$router.push('/ObjectDataList/' + this.$route.params.objectDataListId)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onCancel () {
      this.$router.push('/ObjectDataList/' + this.$route.params.objectDataListId)
    },
    async doAPICalls () {
      for (const v of this.objectSchema.objectProps.getExternal) {
        const data = await this.$http.get(v.api)
        let field = this.objectSchema.fields.find(f => f.model === v.model)
        for (let d of data.data) {
          field[v.ref].push({ value: d.id, name: d.data.name })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectData/ObjectDataEdit.vue